import React from 'react';

/** When true, report pages should omit duplicate chrome (e.g. LeftMenu) inside the Reports hub panel. */
export const ReportEmbedContext = React.createContext(false);
